// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bookings-widget {
  min-height: 225px;
}
.bookings-widget .bookings-container {
  display: flex;
  gap: 10px;
  flex: 1;
}
.bookings-widget .meetings-list-container {
  flex: 1;
  min-width: 0;
}
.bookings-widget .meetings-list-container .meetings-list {
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 8px;
}
.bookings-widget .meetings-list-container .meetings-list.no-meetings {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  text-align: center;
  color: #666;
  font-style: italic;
  border-radius: 8px;
}
.bookings-widget .meetings-list-container .meetings-list .meeting-item {
  padding-left: 6px;
  border-left: 4px solid;
}
.bookings-widget .meetings-list-container .meetings-list .meeting-item.accepted {
  border-left-color: var(--ion-color-success);
}
.bookings-widget .meetings-list-container .meetings-list .meeting-item.declined {
  border-left-color: #ed143d;
}
.bookings-widget .meetings-list-container .meetings-list .meeting-item.pending {
  border-left-color: var(--ion-color-warning);
}
.bookings-widget .meetings-list-container .meetings-list .meeting-item.resourceless {
  border-left-color: #0078d4;
}
.bookings-widget .meetings-list-container .meetings-list .meeting-item .meeting-subject {
  font-weight: 600;
  font-size: 14px;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.bookings-widget .meetings-list-container .meetings-list .meeting-item .meeting-time {
  font-size: 12px;
  color: #888;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.bookings-widget .meetings-list-container .meetings-list .meeting-item .meeting-resource {
  font-size: 11px;
  color: #888;
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.bookings-widget .info-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
  border-left: 3px solid #cccccc;
  width: 120px;
}
.bookings-widget .info-section {
  text-align: center;
  padding: 12px 8px;
  border-radius: 8px;
  line-height: 1.1;
}
.bookings-widget .info-section .value {
  font-size: 20px;
  font-weight: 600;
}
.bookings-widget .info-section .value.booking-date-time {
  display: flex;
  font-size: 14px;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  text-align: center;
}
.bookings-widget .info-section .label {
  font-size: 10px;
  text-align: center;
  color: #666;
}
.bookings-widget .today-date-container {
  font-size: 13px;
  color: #ed143d;
}

.open-calendar-btn {
  background: transparent;
  font-size: 1.4rem;
}
.open-calendar-btn ion-icon {
  color: #ed143d;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/widgets/bookings-widget/bookings-widget.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;AACF;AACE;EACE,aAAA;EACA,SAAA;EACA,OAAA;AACJ;AAEE;EACE,OAAA;EACA,YAAA;AAAJ;AAEI;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,QAAA;AAAN;AACM;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;AACR;AACM;EACE,iBAAA;EACA,sBAAA;AACR;AACQ;EACE,2CAAA;AACV;AAEQ;EACE,0BAAA;AAAV;AAGQ;EACE,2CAAA;AADV;AAIQ;EACE,0BAAA;AAFV;AAKQ;EACE,gBAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAHV;AAMQ;EACE,eAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAJV;AAOQ;EACE,eAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AALV;AAWE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;EACA,8BAAA;EACA,YAAA;AATJ;AAYE;EACE,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AAVJ;AAWI;EACE,eAAA;EACA,gBAAA;AATN;AAWM;EACE,aAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AATR;AAaI;EACE,eAAA;EACA,kBAAA;EACA,WAAA;AAXN;AAcE;EACE,eAAA;EACA,cAAA;AAZJ;;AAgBA;EACE,uBAAA;EACA,iBAAA;AAbF;AAcE;EACE,cAAA;AAZJ","sourcesContent":[".bookings-widget {\n  min-height: 225px;\n\n  .bookings-container {\n    display: flex;\n    gap: 10px;\n    flex: 1;\n  }\n\n  .meetings-list-container {\n    flex: 1;\n    min-width: 0;\n\n    .meetings-list {\n      display: flex;\n      flex-direction: column;\n      height: 100%;\n      gap: 8px;\n      &.no-meetings {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        padding: 16px;\n        text-align: center;\n        color: #666;\n        font-style: italic;\n        border-radius: 8px;\n      }\n      .meeting-item {\n        padding-left: 6px;\n        border-left: 4px solid;\n\n        &.accepted {\n          border-left-color: var(--ion-color-success);\n        }\n\n        &.declined {\n          border-left-color: #ed143d;\n        }\n\n        &.pending {\n          border-left-color: var(--ion-color-warning);\n        }\n\n        &.resourceless {\n          border-left-color: #0078d4;\n        }\n\n        .meeting-subject {\n          font-weight: 600;\n          font-size: 14px;\n          color: #333;\n          white-space: nowrap;\n          overflow: hidden;\n          text-overflow: ellipsis;\n        }\n\n        .meeting-time {\n          font-size: 12px;\n          color: #888;\n          white-space: nowrap;\n          overflow: hidden;\n          text-overflow: ellipsis;\n        }\n\n        .meeting-resource {\n          font-size: 11px;\n          color: #888;\n          display: flex;\n          align-items: center;\n          gap: 4px;\n          white-space: nowrap;\n          overflow: hidden;\n          text-overflow: ellipsis;\n        }\n      }\n    }\n  }\n\n  .info-container {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    justify-content: center;\n    border-left: 3px solid #cccccc;\n    width: 120px;\n  }\n\n  .info-section {\n    text-align: center;\n    padding: 12px 8px;\n    border-radius: 8px;\n    line-height: 1.1;\n    .value {\n      font-size: 20px;\n      font-weight: 600;\n\n      &.booking-date-time {\n        display: flex;\n        font-size: 14px;\n        flex-direction: column;\n        align-items: center;\n        gap: 2px;\n        text-align: center;\n      }\n    }\n\n    .label {\n      font-size: 10px;\n      text-align: center;\n      color: #666;\n    }\n  }\n  .today-date-container {\n    font-size: 13px;\n    color: #ed143d;\n  }\n}\n\n.open-calendar-btn {\n  background: transparent;\n  font-size: 1.4rem;\n  ion-icon {\n    color: #ed143d;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
